<template>
    <v-container>
        <FormularioCadastroProdutos :produto-edicao="produto_para_editar" @limpaProdutoEdicao="limpaProdutoEdicao" @registroInserido="registroInserido" />
        <ListagemProdutos @editar="editarProduto" :atualiza-listagem="atualiza_listagem" />
    </v-container>
</template>
<script>
  import FormularioCadastroProdutos from '../../../components/cadastros/produtos/FormularioCadastroProdutos.vue'
  import ListagemProdutos from '../../../components/cadastros/produtos/ListagemProdutos.vue'
  export default {
    name: 'Produtos',
    components: { FormularioCadastroProdutos, ListagemProdutos },
    data () {
      return {
        produto_para_editar: null,
        atualiza_listagem: false
      }
    },
    methods: {
      limpaProdutoEdicao () {
        this.produto_para_editar = null
      },
      editarProduto (item) {
        this.produto_para_editar = item
      },
      registroInserido () {
        this.atualiza_listagem = !this.atualiza_listagem
      }
    }
  }
</script>
